var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionsTable',{attrs:{"source":'payments_collection',"fullHeadings":_vm.tableHeadings,"downloadHeadings":_vm.headings}})
}
var staticRenderFns = []

export { render, staticRenderFns }